/**
 * @classdesc Hungarian Language Pack
 * @desc This class will used to translate tokens into the Hungarian language.
 * @namespace Languages.Hungarian
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Hungarian
 */
export const dictionary = {
	'years'   : 'Év',
    'months'  : 'Hónap',
    'days'    : 'Nap',
    'hours'   : 'Óra',
    'minutes' : 'Perc',
    'seconds' : 'Másodperc'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Hungarian
 */
export const aliases = ['hu', 'hu-hu', 'hungarian'];
